import { ResetPasswordEmailData } from '../../../types/requests';
import { ConstructPost } from '../../types/ConstructPost';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const postSendResetPasswordEmail = (
  constructPost: ConstructPost,
  data: ResetPasswordEmailData,
  headers?: Record<string, string>,
): Promise<unknown> =>
  constructPost(
    `${AUTH_BASE_PATH}/password/email`,
    { data, headers },
    { preventDefaultErrorToast: true },
  );
